import { Seo } from "@/components/Seo";
import { HomeHero } from "@/components/HomeHero";
import { HomeIntro } from "@/components/HomeIntro";
import { HomeBusinessStatement } from "@/components/HomeBusinessStatement";
import { HomeCTA } from "@/components/HomeCTA";

export default function Home() {
  return (
    <>
      <Seo
        title="Premium Agricultural Products from India"
        description="RKG NATURALS - Proprietorship engaged in Import, Export and Wholesale trade of quality agricultural products from India."
        path="/"
      />
      <div data-testid="home-page">
        <HomeHero />
        <HomeIntro />
        <HomeBusinessStatement />
        <HomeCTA />
      </div>
    </>
  );
}
